import { DataProvider, IErrorModel, useMutation } from "@nf/common";

export const useUncancelSubscription = () =>
  useMutation<void, IErrorModel, number>((id) =>
    DataProvider.uncancelSubscription(id)
  );
